export default "__VITE_ASSET__CPzVhhEM__"